import React from 'react';
import {
    IconCopyL,
    IconEyeL,
    IconPauseCircleL,
    IconPenL,
    IconPlayCircleL,
    IconRocketL,
    IconShareL,
    IconTrashL,
} from '../../../icons';
import {
    LISTING_STATE_CLOSED,
    LISTING_STATE_DRAFT,
    LISTING_STATE_PUBLISHED,
} from '../../../util/types';
import Controls from '../../Controls/Controls';
import {
    MODAL_DELETE_DRAFT,
    MODAL_PAUSE,
    MODAL_SHARE,
    REASON_TO_PAUSE_STATUS_NO_ASSETS,
} from '../constants';
import { useManageListingCardContext } from '../ManageListingCardContext';

import css from '../ManageListingCard.css';
import { getListingDisplayState } from '../helpers';

const getControlOptions = ({ listing, actions, openModal }) => {
    const { state } = listing.attributes;
    const isPublished = state === LISTING_STATE_PUBLISHED;
    const isClosed = state === LISTING_STATE_CLOSED;
    const isDraft = state === LISTING_STATE_DRAFT;

    const displayState = getListingDisplayState(listing);
    const isNoAssetsDisplayState = displayState === REASON_TO_PAUSE_STATUS_NO_ASSETS;

    const controlOptions = [
        {
            label: 'Vorschau',
            icon: <IconEyeL />,
            action: actions.navigateToListingPage,
            id: 'action-preview',
        },
        {
            label: 'Bearbeiten',
            icon: <IconPenL />,
            action: actions.navigateToEditListingPage,
            id: 'action-edit',
        },
        {
            label: 'Duplizieren',
            icon: <IconCopyL />,
            action: actions.duplicateListing,
            id: 'action-duplicate',
        },
        {
            label: 'Teilen',
            icon: <IconShareL />,
            action: () => openModal(MODAL_SHARE),
            allowed: isPublished || isClosed,
            id: 'action-share',
        },
        {
            label: 'Pakete',
            icon: <IconRocketL />,
            action: actions.navigateToPackagesPage,
            allowed: isPublished || isClosed,
            id: 'action-packages',
        },
        {
            label: 'Pausieren',
            icon: <IconPauseCircleL />,
            action: () => openModal(MODAL_PAUSE),
            allowed: isPublished,
            id: 'action-pause',
        },
        {
            label: 'Reaktivieren',
            icon: <IconPlayCircleL />,
            action: actions.reactivateListing,
            allowed: isClosed,
            id: 'action-reactivate',
        },
        {
            label: 'Löschen',
            icon: <IconTrashL />,
            action: () => openModal(MODAL_DELETE_DRAFT),
            allowed: isDraft,
            id: 'action-delete',
        },
    ];

    const filterByAssetsAvailable = option => {
        if (option.id === 'action-reactivate') {
            return !isNoAssetsDisplayState;
        }
        return true;
    };

    return controlOptions.filter(filterByAssetsAvailable);
};

/** UI state of the menu is managed by the page, as only one card menu can be opened at once */
const ListingControls = ({ isOpened, onToggle, onDismiss }) => {
    const context = useManageListingCardContext();

    return (
        <Controls
            rootClassName={css.controls}
            isOpened={isOpened}
            handleToggle={onToggle}
            controlHolderProps={{
                outsideClickHandler: onDismiss,
                staticTooltipStateHandler: onDismiss,
            }}
            menu={<Controls.Menu controlOptions={getControlOptions(context)} />}
        >
            <Controls.Trigger />
        </Controls>
    );
};

export default ListingControls;
